import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import TableCell from 'src/components/Table/TableCell';
import EditIcon from '@mui/icons-material/Edit';
import useStyles from '../styles';

const DenominationRow = ({ name, id, openEdit, handleDelete }) => {
  const { classes } = useStyles();

  return (
    <TableRow hover>
      <TableCell>{name}</TableCell>
      <TableCell style={{ width: 130 }}>
        <IconButton
          style={{ padding: '0 12px' }}
          onClick={openEdit}
          key="edit"
          aria-label="Edit"
          color="inherit"
        >
          <EditIcon className={classes.editIcon} />
        </IconButton>
        <IconButton
          style={{ padding: '0 12px' }}
          onClick={() => handleDelete(id)}
          key="delete"
          aria-label="Delete"
          color="inherit"
        >
          <DeleteIcon className={classes.deleteIcon} />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

DenominationRow.propTypes = {
  name: PropTypes.string,
  id: PropTypes.number,
  openEdit: PropTypes.func,
  handleDelete: PropTypes.func
};

export default DenominationRow;
